var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60.9998 33.041C48.3423 33.041 40.6665 43.3093 40.6665 55.916V86.416H81.3332V55.916C81.3332 43.3093 73.6573 33.041 60.9998 33.041Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0002 110.139C66.5918 110.139 71.1668 105.564 71.1668 99.972H50.8335C50.8335 105.564 55.4085 110.139 61.0002 110.139ZM91.5002 79.6387V54.222C91.5002 38.6162 83.2143 25.552 68.6252 22.0953V18.6387C68.6252 14.4195 65.2193 11.0137 61.0002 11.0137C56.781 11.0137 53.3752 14.4195 53.3752 18.6387V22.0953C38.8368 25.552 30.5002 38.5653 30.5002 54.222V79.6387L20.3335 89.8053V94.8887H101.667V89.8053L91.5002 79.6387ZM81.3335 84.722H40.6668V54.222C40.6668 41.6153 48.3427 31.347 61.0002 31.347C73.6577 31.347 81.3335 41.6153 81.3335 54.222V84.722Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigbell);
export default __webpack_public_path__ + "static/media/bigbell.23824330db0a533cb8555ecdd2936c86.svg";
export { ForwardRef as ReactComponent };